import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import "@/App.css";

// Prefetch das rotas mais acessadas assim que o main bundle carrega
// (não bloqueia — usa idle callback quando disponível).
const preloadRoutes = () => {
  import("@/pages/EventDetail");
  import("@/pages/Checkout");
  import("@/pages/Login");
};
if (typeof window !== "undefined") {
  const schedule = window.requestIdleCallback || ((cb) => setTimeout(cb, 800));
  schedule(preloadRoutes);
}

const EventDetail = lazy(() => import("@/pages/EventDetail"));
const Checkout = lazy(() => import("@/pages/Checkout"));
const Confirmation = lazy(() => import("@/pages/Confirmation"));
const MyTickets = lazy(() => import("@/pages/MyTickets"));
const TicketView = lazy(() => import("@/pages/TicketView"));
const Login = lazy(() => import("@/pages/Login"));
const OrganizerDashboard = lazy(() => import("@/pages/OrganizerDashboard"));
const EventReport = lazy(() => import("@/pages/EventReport"));
const PortariaScan = lazy(() => import("@/pages/PortariaScan"));
const PortariaHome = lazy(() => import("@/pages/PortariaHome"));
const AffiliateRedirect = lazy(() => import("@/pages/AffiliateRedirect"));
const OrganizerPublicPage = lazy(() => import("@/pages/OrganizerPublicPage"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));
const LEGAL_ROUTES = ["termos-de-uso", "politica-de-privacidade", "reembolso-e-cancelamento", "politica-de-pagamentos",
  "regras-dos-ingressos", "termos-produtores", "politica-de-cookies", "ajuda", "politica-antifraude", "contato"];

const Fallback = () => (
  <div className="max-w-7xl mx-auto px-5 md:px-8 py-12 text-slate-400">Carregando…</div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors closeButton/>
        <Suspense fallback={<Fallback/>}>
          <Routes>
            <Route path="/" element={<Layout><Home/></Layout>}/>
            <Route path="/eventos/:id" element={<Layout><EventDetail/></Layout>}/>
            <Route path="/checkout" element={<Layout><Checkout/></Layout>}/>
            <Route path="/confirmacao/:orderId" element={<Layout><Confirmation/></Layout>}/>
            <Route path="/meus-ingressos" element={<Layout><MyTickets/></Layout>}/>
            <Route path="/ingresso/:id" element={<Layout><TicketView/></Layout>}/>
            <Route path="/login" element={<Layout><Login/></Layout>}/>
            <Route path="/organizador" element={<Layout><OrganizerDashboard/></Layout>}/>
            <Route path="/organizador/evento/:id/relatorio" element={<Layout><EventReport/></Layout>}/>
            <Route path="/portaria" element={<Layout><PortariaHome/></Layout>}/>
            <Route path="/portaria/scan" element={<Layout><PortariaScan/></Layout>}/>
            <Route path="/a/:slug" element={<AffiliateRedirect/>}/>
            <Route path="/o/:slug" element={<Layout><OrganizerPublicPage/></Layout>}/>
            {LEGAL_ROUTES.map((r) => <Route key={r} path={`/${r}`} element={<Layout><LegalPage/></Layout>}/>)}
          </Routes>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
